import { POLIZA_COMPLETA, CHEQUERA, SORCA, CERTIFICADO_COBERTURA, FACTURA_ELECTRONICA } from "../data/constants";

const pdf_services = {
    [POLIZA_COMPLETA]: "/SeguroCompleto",
    [CHEQUERA]: "/Chequera",
    [SORCA]: "/Sorca",
	[CERTIFICADO_COBERTURA]: "/CertificadoCoberturaSocios",
};

const obtenerPDF = (nombrePDF, params) => {
    if (nombrePDF === FACTURA_ELECTRONICA) {
        return fetch(
            `${process.env.REACT_APP_IMPRESION_FACTURA_URL}/factura/${params.cod}`
        ).then((res) => {
            if (res.status === 404) {
                const error = new Error("FACTURA_NO_DISPONIBLE");
                error.status = 404;
                return Promise.reject(error);
            }
            if (!res.ok) {
                return Promise.reject(new Error("Error al obtener factura"));
            }
            return res.blob();
        });
    }

    let queryParamsURL = `codSeguro=${params.cod}&Ramo=${params.ramo.nro}`;
    if (params.anexo)
        queryParamsURL = `${queryParamsURL}&Anexo=${params.anexo}`;

    return fetch(
        `${process.env.REACT_APP_IMPRESION_URL}${pdf_services[nombrePDF]}.aspx?${queryParamsURL}`
    ).then((res) => res.blob());
};

const authFetch = (url, body) => {
    return fetch(`${process.env.REACT_APP_BACKEND_AUTH_URL}${url}`, {
        method: "POST",
        body: JSON.stringify({
            ...body,
        }),
        headers: {
            "Content-Type": "application/json",
        },
    }).then((res) => res.json());
};

const login = (cuit, password) => authFetch("/LoginUser", { cuit, password });

const forgotPassword = (email) => authFetch("/ForgotPassword", { email });

const forgotPasswordByCuit = (cuit) => authFetch("/ForgotPasswordByCuit", { cuit });

const validateCode = ({email,cuit}, code) =>
    authFetch("/ValidateCode", { email,cuit, code });

const resetPassword = ({email,cuit}, newPassword) =>
    authFetch("/ResetPassword", { email,cuit,code:"newPassword", newPassword });

const mockFetchAPI = () => {
    return new Promise((resolve, reject) => {
        let success = true;

        setTimeout(() => {
            if (success) {
                resolve({ Resul: true });
            } else {
                reject("Error");
            }
        }, 1500);
    });
};

export {
    obtenerPDF,
    login,
    forgotPassword,
    forgotPasswordByCuit,
    validateCode,
    resetPassword,
    mockFetchAPI,
};
